const DATE_FILTER_KEY = 'dateFilter';
const DATE_FILTER_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export function isValidDateFilter(dateFilter?: string | null): boolean {
  if (!dateFilter || !DATE_FILTER_REGEX.test(dateFilter)) {
    return false;
  }
  const [year, month, day] = dateFilter.split("-").map((value) => Number(value));
  if (
    !Number.isInteger(year) ||
    !Number.isInteger(month) ||
    !Number.isInteger(day)
  ) {
    return false;
  }
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
}

export const dateFilterStorage = {
  get(): string | null {
    try {
      const value = localStorage.getItem(DATE_FILTER_KEY);
      if (isValidDateFilter(value)) {
        return value;
      }
      if (value) {
        localStorage.removeItem(DATE_FILTER_KEY);
      }
      return null;
    } catch (error) {
      console.warn('Failed to read date filter from localStorage:', error);
      return null;
    }
  },

  set(dateFilter: string): void {
    try {
      if (!isValidDateFilter(dateFilter)) {
        console.warn('Rejected invalid date filter value:', dateFilter);
        return;
      }
      localStorage.setItem(DATE_FILTER_KEY, dateFilter);
    } catch (error) {
      console.warn('Failed to save date filter to localStorage:', error);
    }
  },

  remove(): void {
    try {
      localStorage.removeItem(DATE_FILTER_KEY);
    } catch (error) {
      console.warn('Failed to remove date filter from localStorage:', error);
    }
  }
};
